import { useEffect } from 'react';

export const AppPreloader = () => {
  useEffect(() => {
    // @ts-ignore
    const element = window.document.getElementById('preloader')!;
    element.style.opacity = '0';
  }, []);

  return null;
};
